module.exports = __webpack_public_path__ + "img/adjust_paln_bg.faaceb84.png";